export default "../css/cd89dc1026649f4f4df09dafa5a13bd8.ttf";